/* ==========================================================================
   collection-filters.js — v6
   
   - Capture phase listeners para bypassear Instant
   - Thumbs visuales del price range slider sincronizados con los inputs
   ========================================================================== */

'use strict';

document.addEventListener('DOMContentLoaded', function () {

  var form      = document.getElementById('CollectionFiltersForm');
  var sidebar   = document.getElementById('collection-filters-sidebar');
  var mobileBtn = document.querySelector('[data-filters-mobile-btn]');
  var overlay   = document.querySelector('.cf-sidebar-overlay');

  if (!form) {
    console.warn('[CF] No se encontró #CollectionFiltersForm');
    return;
  }

  /* ------------------------------------------------------------------
     Bloquear que Instant intercepte eventos dentro del sidebar
     ------------------------------------------------------------------ */
  sidebar.addEventListener('click',     function (e) { e.stopPropagation(); }, true);
  sidebar.addEventListener('mousedown', function (e) { e.stopPropagation(); }, true);

  /* ------------------------------------------------------------------
     Change en CAPTURE PHASE (corre antes que Instant)
     ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    if (!e.target.closest('#CollectionFiltersForm')) return;
    if (e.target.matches('[data-filter-price-min], [data-filter-price-max]')) return;
    e.stopPropagation();
    setPillActive(e.target, e.target.checked);
    scheduleFilter();
  }, true);

  /* ------------------------------------------------------------------
     Sincronizar pills con URL actual
     ------------------------------------------------------------------ */
  function syncFromURL() {
    var params = new URLSearchParams(location.search);
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      var vals = params.getAll(cb.name);
      cb.checked = vals.includes(cb.value);
      setPillActive(cb, cb.checked);
    });
    updatePriceRangeFill();
  }

  function setPillActive(cb, active) {
    var pill = cb.closest('.cf-pill');
    if (pill) pill.classList.toggle('cf-pill--active', active);
  }

  syncFromURL();

  /* ------------------------------------------------------------------
     Debounce
     ------------------------------------------------------------------ */
  var debounceTimer = null;
  function scheduleFilter() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyFilter, 350);
  }

  /* ------------------------------------------------------------------
     Construir params
     ------------------------------------------------------------------ */
  function buildParams() {
    var params = new URLSearchParams();

    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
      params.append(cb.name, cb.value);
    });

    var minInput = form.querySelector('[data-filter-price-min]');
    var maxInput = form.querySelector('[data-filter-price-max]');
    // Shopify Liquid devuelve los precios en centavos → dividir por 100 para la URL
    if (minInput && parseFloat(minInput.value) > parseFloat(minInput.min)) {
      params.set(minInput.name, (parseFloat(minInput.value) / 100).toFixed(2));
    }
    if (maxInput && parseFloat(maxInput.value) < parseFloat(maxInput.max)) {
      params.set(maxInput.name, (parseFloat(maxInput.value) / 100).toFixed(2));
    }

    var existingSort = new URLSearchParams(location.search).get('sort_by');
    if (existingSort) params.set('sort_by', existingSort);

    return params;
  }

  /* ------------------------------------------------------------------
     Aplicar filtro: pushState + popstate para que Instant reaccione.
     Si no reacciona, fallback a link click → reload real.
     ------------------------------------------------------------------ */
  function applyFilter() {
    var params = buildParams();
    var newURL = location.pathname + (params.toString() ? '?' + params.toString() : '');

    console.log('[CF] Aplicando filtro →', newURL);
    history.pushState({ cf: true, params: params.toString() }, '', newURL);

    window.dispatchEvent(new PopStateEvent('popstate', {
      state: history.state,
      bubbles: false,
      cancelable: false
    }));

    var cardsBefore = getCardCount();
    setTimeout(function () {
      if (getCardCount() !== cardsBefore) {
        console.log('[CF] ✓ Instant actualizó los productos');
        setTimeout(syncFromURL, 300);
        return;
      }

      console.log('[CF] popstate no funcionó, intentando link...');
      triggerInstantLinkNav(newURL);
    }, 800);
  }

  function triggerInstantLinkNav(url) {
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('data-instant-action-type', 'open-page');
    link.setAttribute('data-instant-href', url);
    link.style.cssText = 'position:absolute;opacity:0;pointer-events:none;';

    var container = document.querySelector('[data-instant-type="container"]');
    (container || document.body).appendChild(link);
    link.click();
    link.remove();

    var cardsBefore = getCardCount();
    setTimeout(function () {
      if (getCardCount() !== cardsBefore) {
        console.log('[CF] ✓ Link nav funcionó');
        setTimeout(syncFromURL, 300);
        return;
      }
      console.log('[CF] Fallback → reload real');
      sessionStorage.setItem('cf_scroll', String(window.scrollY));
      location.href = url;
    }, 1000);
  }

  function getCardCount() {
    return document.querySelectorAll('[data-instant-form-product-url]').length;
  }

  /* ------------------------------------------------------------------
     Restaurar scroll tras reload real
     ------------------------------------------------------------------ */
  var savedScroll = sessionStorage.getItem('cf_scroll');
  if (savedScroll) {
    sessionStorage.removeItem('cf_scroll');
    requestAnimationFrame(function () {
      window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'instant' });
    });
  }

  /* ------------------------------------------------------------------
     MutationObserver: re-attachar si Instant reemplaza el form
     ------------------------------------------------------------------ */
  var instantRoot = document.querySelector('[data-instant-type="container"]');
  if (instantRoot) {
    var syncTimer = null;
    new MutationObserver(function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        var freshForm = document.getElementById('CollectionFiltersForm');
        if (freshForm && freshForm !== form) {
          form = freshForm;
          initPriceRange();
        }
        syncFromURL();
      }, 300);
    }).observe(instantRoot, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------
     Clear filters
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-clear-filters]')) return;
    e.stopPropagation();
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.checked = false;
      setPillActive(cb, false);
    });
    var minInput = form.querySelector('[data-filter-price-min]');
    var maxInput = form.querySelector('[data-filter-price-max]');
    if (minInput) minInput.value = minInput.min;
    if (maxInput) maxInput.value = maxInput.max;
    updatePriceRangeFill();
    scheduleFilter();
  }, true);

  /* ------------------------------------------------------------------
     Price Range — listeners
     ------------------------------------------------------------------ */
  function initPriceRange() {
    var minInput = form.querySelector('[data-filter-price-min]');
    var maxInput = form.querySelector('[data-filter-price-max]');
    if (!minInput || !maxInput) return;

    minInput.addEventListener('input', function () {
      if (parseFloat(minInput.value) > parseFloat(maxInput.value)) minInput.value = maxInput.value;
      updatePriceRangeFill();
    });
    maxInput.addEventListener('input', function () {
      if (parseFloat(maxInput.value) < parseFloat(minInput.value)) maxInput.value = minInput.value;
      updatePriceRangeFill();
    });
    minInput.addEventListener('change', scheduleFilter);
    maxInput.addEventListener('change', scheduleFilter);
    updatePriceRangeFill();
  }

  /* ------------------------------------------------------------------
     Price Range — actualizar fill + mover thumbs visuales
     ------------------------------------------------------------------ */
  function updatePriceRangeFill() {
    var minInput  = form.querySelector('[data-filter-price-min]');
    var maxInput  = form.querySelector('[data-filter-price-max]');
    var fill      = form.querySelector('.cf-price-range__fill');
    var thumbMin  = form.querySelector('[data-cf-thumb="min"]');
    var thumbMax  = form.querySelector('[data-cf-thumb="max"]');
    var minLabel  = document.getElementById('price-min-label');
    var maxLabel  = document.getElementById('price-max-label');

    if (!minInput || !maxInput || !fill) return;

    var rangeMax = parseFloat(maxInput.max) || 1;
    var low      = parseFloat(minInput.value) || 0;
    var high     = parseFloat(maxInput.value) || rangeMax;
    var leftPct  = (low  / rangeMax) * 100;
    var rightPct = (high / rangeMax) * 100;

    // Relleno naranja
    fill.style.left  = leftPct + '%';
    fill.style.width = (rightPct - leftPct) + '%';

    // Círculos visuales
    if (thumbMin) thumbMin.style.left = leftPct + '%';
    if (thumbMax) thumbMax.style.left = rightPct + '%';

    // Labels de precio (centavos → moneda real)
    if (minLabel) minLabel.textContent = formatMoney(low);
    if (maxLabel) maxLabel.textContent = formatMoney(high);
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ARS',
      maximumFractionDigits: 0
    }).format(cents / 100);
  }

  /* ------------------------------------------------------------------
     Accordions (capture phase)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.cf-group__toggle');
    if (!toggle) return;
    e.stopPropagation();
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
  }, true);

  /* ------------------------------------------------------------------
     Mobile drawer
     ------------------------------------------------------------------ */
  function closeDrawer() {
    if (sidebar) sidebar.classList.remove('cf-sidebar--open');
    if (overlay) overlay.classList.remove('cf-sidebar-overlay--visible');
    document.body.style.overflow = '';
  }

  if (mobileBtn && sidebar) {
    mobileBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      sidebar.classList.add('cf-sidebar--open');
      if (overlay) overlay.classList.add('cf-sidebar-overlay--visible');
      document.body.style.overflow = 'hidden';
    }, true);
    if (overlay) overlay.addEventListener('click', closeDrawer, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ------------------------------------------------------------------
     Init
     ------------------------------------------------------------------ */
  initPriceRange();
  console.log('[CF] ✅ v6 activo');
});